
window.spreadsheetInstance = null;

window.initSpreadsheet = function (netInstance) {
    var script = document.getElementById('spreadsheetScript');
    if (script) {
        window.createSpreadsheetInstance(netInstance);
    }
    else {
        script = document.createElement('script');
        script.id = 'spreadsheetScript';
        script.onload = function () {
            window.createSpreadsheetInstance(netInstance);
        };
        script.src = '/syncfusion/ej2.min.js?v=2.11.0';
        document.head.appendChild(script);
    }
};

window.createSpreadsheetInstance = function (netInstance) {
    var spreadsheet = new ej.spreadsheet.Spreadsheet({
        enableClipboard: false,
        height: '95vh',
        allowDelete: false,
        allowInsert: false,
        allowSave: true,
        allowOpen: true,
        showRibbon: true
    }, '#spreadsheetContainer');
    window.spreadsheetInstance = {
        sh: spreadsheet,
        net: netInstance
    };
    spreadsheet.sh.hideRibbonTabs(['Data', 'View']);
    netInstance.invokeMethodAsync('OpenFile');
};

window.spreadsheetDeliver = function () {
    var netInstance = window.spreadsheetInstance.net;
    var spreadsheet = window.spreadsheetInstance.sh;
    netInstance.invokeMethodAsync('InitLoading');

    spreadsheet.saveAsJson().then(function (result) {
        var jsonString = JSON.stringify(result.jsonObject.Workbook);
        netInstance.invokeMethodAsync('Deliver', jsonString);
    });
}

window.spreadsheetSaveChanges = function () {
    var netInstance = window.spreadsheetInstance.net;
    var spreadsheet = window.spreadsheetInstance.sh;
    netInstance.invokeMethodAsync('InitLoading');

    spreadsheet.saveAsJson().then(function (result) {
        var jsonString = JSON.stringify(result.jsonObject);
        netInstance.invokeMethodAsync('SaveChanges', jsonString);
    });
}

window.openSpreadsheetFile = function (json) {
    window.spreadsheetInstance.sh.openFromJson({ file: json });
}